import { observer } from "mobx-react";
import { Dialog } from "@/components-v2/Dialog";
import { useTranslation } from "@/stores/RootStoreContext";
import { VBox } from "@/components-v2/Box";
import { MTextInput } from "@/components-v2/TextInput";
import { DuplicateProjectDialogState } from "./duplicateProjectDomain";
import { MSelect } from "@/components-v2/Select";

export const DuplicateProjectDialog = observer((props: DuplicateProjectDialogState) => {
  const { t } = useTranslation();
  return (
    <Dialog
      title={t("dbot.duplicate")}
      onCancel={props.onCancel}
      onSubmit={props.onSave}
      submitLabel={t("duplicate")}
      isSubmitting={props.isSaving}
    >
      <VBox gap={"md"}>
        <MSelect label={t("dbot.duplicate.copy-to")} model={props.targetCompany} />
        <MTextInput label={t("dbot.new-project-name.label")} model={props.projectName} />
      </VBox>
    </Dialog>
  );
});
